import type { ComponentProps } from 'react';

import DashboardItemSegments from './DashboardItemSegments';
import DashboardMetricGrid from './DashboardMetricGrid';
import DashboardStatusOverview from './DashboardStatusOverview';
import { DASHBOARD_ITEM_SEGMENTS_ID } from '../dashboard.constants';
import type {
  EDashboardSegmentKey,
  TDashboardMetric,
  TDashboardStatusChartDatum,
  TDashboardViewModel,
} from '../types/dashboard.types';

type TProps = {
  viewModel: TDashboardViewModel;
  metrics: TDashboardMetric[];
  statusChart: TDashboardStatusChartDatum[];
  selectedSegmentKey: EDashboardSegmentKey;
  onMetricSegmentChange: (segmentKey: EDashboardSegmentKey) => void;
  itemSegmentsProps: ComponentProps<typeof DashboardItemSegments>;
};

const DashboardContent = ({
  viewModel,
  metrics,
  statusChart,
  selectedSegmentKey,
  onMetricSegmentChange,
  itemSegmentsProps,
}: TProps) => (
  <>
    <DashboardMetricGrid
      metrics={metrics}
      controlsId={DASHBOARD_ITEM_SEGMENTS_ID}
      selectedSegmentKey={selectedSegmentKey}
      onSelectedSegmentKeyChange={onMetricSegmentChange}
    />

    <DashboardStatusOverview counters={viewModel.counters} statusChart={statusChart} />

    <DashboardItemSegments {...itemSegmentsProps} />
  </>
);

export default DashboardContent;
